site.mMenu = {
	init: function() {
		/*var $menu = $('> .mmLevel1', '#mainmenu');
		if ($menu.length === 0) return false;

		var $body = $('body'),
			$html = $('<div id="mMenu" role="navigation"></div>'),
			$mMenu = $menu.clone().removeAttr('id');
		$('ul',$mMenu).removeAttr('id');
		$html.append($mMenu);
		$body.append($html);

		var $navbar = '<a href="#mm-1" class="home"><span class="sr-only">Heim</span></a>';*/

		var $mMenu = $('#mainmenu').clone().prop('id', 'mMenu').attr('role','navigation'),
			$body = $('body');

		$('ul.mmLevel1:gt(0)',$mMenu).remove().children('li').appendTo($('ul.mmLevel1:eq(0)',$mMenu));
		$body.append($mMenu);

		var $navbar = '<a href="#mm-1" class="home"><span class="sr-only">Heim</span></a>';

		$('#mMenu').mmenu({
			// options
			offCanvas: {
				position: "right"
			},
			extensions: ["theme-moya"],
			navbars: [{
				position: "top",
				content: $navbar,
			}]
		},{
			// configuration
			classNames: {
				selected:"active"
			},
			offCanvas: {
				menuInjectMethod: "append"
			}
		});

		var API = $("#mMenu").data( "mmenu" );

		$("#mainmenuToggle").click(function() {
			API.close();
		});


		$('.mm-page.mm-slideout').removeClass('mm-slideout');

		//var $mSearch = $('#searchForm').clone().prop('id','mSearchForm');
		//$('.mm-navbar-top','#mMenu').append($mSearch);

		$('#mMenu .mm-next').append('<span class="sr-only">Áfram</span>');
		$('#mMenu .mm-btn.mm-prev').append('<span class="sr-only">Aftur</span>');
		$('#mSearchForm label').remove();

		var $div = $('.mm-panel:first-child', '.mm-panels');
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if (mutation.attributeName === "class") {
					var attributeValue = $(mutation.target).prop(mutation.attributeName);
					//if ($body.hasClass('')
					if (attributeValue.indexOf('mm-subopened') > 0) {
						$body.addClass('mm-subopened');
					}
					else {
						$body.removeClass('mm-subopened');
					}

				}
			});
		});
		observer.observe($div[0], {
			attributes: true
		});

		if ($div.hasClass('mm-subopened')) {
			$body.addClass('mm-subopened');
		}
	}
};

site.inits.push('site.mMenu.init()');
